import React, { useState, useEffect } from "react";
import { Form, InputNumber, Button, Card, Typography, Row, Col } from "antd";

const { Title, Text } = Typography;

const RentalYieldCalculator = () => {
  const [rentalYield, setRentalYield] = useState(null);
  const [investmentQuality, setInvestmentQuality] = useState("");
  const [riskWarning, setRiskWarning] = useState("");
  const [currency, setCurrency] = useState("$");

  const formatNumber = (value) => {
    if (!value) return "";
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  const parseNumber = (value) => {
    return value ? value.replace(/\s/g, "") : "";
  };

  useEffect(() => {
        fetch("https://ipapi.co/json/")
          .then((res) => res.json())
          .then((data) => {
            const countryCode = data.country_code; // e.g., ZA, US
            setCurrency(getCurrencyCode(countryCode));
          })
          .catch((err) => {
            console.error("Error fetching currency:", err);
            setCurrency("$"); // Fallback
          });
      }, []);
    
      const getCurrencyCode = (countryCode) => {
        const currencyMap = {
          ZA: "R",   // South Africa
          US: "$",   // United States
          GB: "£",   // United Kingdom
          NG: "₦",   // Nigeria
          KE: "KES", // Kenya
          IN: "₹",   // India
        };
        return currencyMap[countryCode] || "$";
      };

  const calculateRentalYield = (values) => {
    const { monthlyRent, annualExpenses, propertyPrice, vacancyRate } = values;
    
    const annualRentIncome = monthlyRent * 12 * (1 - vacancyRate / 100);
    const netRentalYield = ((annualRentIncome - annualExpenses) / propertyPrice) * 100;

    setRentalYield(netRentalYield.toFixed(2));

    if (netRentalYield < 4) {
      setInvestmentQuality("Poor Investment");
      setRiskWarning("Low returns. Property costs might be too high compared to rent.");
    } else if (netRentalYield >= 4 && netRentalYield <= 6) {
      setInvestmentQuality("Moderate Investment");
      setRiskWarning("Safe and stable, but may have lower cash flow.");
    } else if (netRentalYield > 6 && netRentalYield <= 10) {
      setInvestmentQuality("Good Investment");
      setRiskWarning("Balanced profitability and manageable risks.");
    } else {
      setInvestmentQuality("High Yield - Potentially Risky");
      setRiskWarning("High rental yield can indicate potential risks such as high tenant turnover, maintenance issues, or low long-term appreciation. Research carefully before investing.");
    }
  };

  return (
    <Card title="Rental Yield Calculator" style={{ maxWidth: 800, margin: "auto", marginTop: 20 }}>
      <Row gutter={24}>
        <Col span={15}>
          <Form layout="vertical" onFinish={calculateRentalYield} initialValues={{ monthlyRent: 6000, annualExpenses: 30000, propertyPrice: 400000, vacancyRate: 0 }}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label={"Monthly Rent Income (" + currency + ")"} name="monthlyRent" rules={[{ required: true, message: "Please enter the monthly rent income" }]}> 
                  <InputNumber style={{ width: "100%" }} min={1} step={100} formatter={formatNumber} parser={parseNumber} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label={"Annual Expenses (" + currency + ")"} name="annualExpenses" rules={[{ required: true, message: "Please enter the annual expenses" }]}> 
                  <InputNumber style={{ width: "100%" }} min={0} step={100} formatter={formatNumber} parser={parseNumber} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item  label={<span style={{ fontSize: "12px"}}>
                    {"Property Purchase Price (" + currency + ")"}
                </span>} name="propertyPrice" rules={[{ required: true, message: "Please enter the property purchase price" }]}> 
                  <InputNumber style={{ width: "100%" }} min={1} step={1000} formatter={formatNumber} parser={parseNumber} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Vacancy Rate (%)" name="vacancyRate" rules={[{ required: true, message: "Please enter the estimated vacancy rate" }]}> 
                  <InputNumber style={{ width: "100%" }} min={0} max={100} step={0.1} />
                </Form.Item>
              </Col>
            </Row>
            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                Calculate Rental Yield
              </Button>
            </Form.Item>
          </Form>
        </Col>
        <Col span={9}>
          {rentalYield !== null && (
            <Card style={{ textAlign: "center" }}>
              <Title level={4}>Net Rental Yield</Title>
              <Text strong style={{ fontSize: "18px" }}>
                {rentalYield}%
              </Text>
              {/*
              <Text style={{ display: "block", marginTop: 10, fontSize: "16px" }}>
                {investmentQuality}
              </Text>
              {rentalYield > 10 && (
                <Text style={{ display: "block", marginTop: 10, color: "red", fontSize: "14px" }}>
                  {riskWarning}
                </Text>
              )}
                */
              }
            </Card>
          )}
        </Col>
      </Row>
    </Card>
  );
};

export default RentalYieldCalculator;